import OadpTabItem from './oadp-tab-item';
export default OadpTabItem;
